<template>
  <div id="FAQManagement">
    <panel
      Title="پرسش و پاسخ‌های متداول"
      Des="از طریق این فرم می‌توانید پرسش‌ها و پاسخ‌های متداول را مدیریت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-card>
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-question-circle ml-2"></i>لیست پرسش‌ها و پاسخ‌های
              متداول
            </h6>
          </template>
          <template slot="content">
            <div class="faq-results">
              <div class="faq-cards" dir="rtl">
                <div class="faq-cards__toolbar">
                  <input
                    type="search"
                    class="faq-cards__search"
                    v-model="faqSearch"
                    placeholder="جستجو"
                    aria-label="جستجو"
                  />
                  <button
                    type="button"
                    class="faq-cards__add"
                    @click="onAdd"
                  >
                    <i class="fas fa-plus" aria-hidden="true"></i>
                    افزودن
                  </button>
                </div>
                <p v-if="!faqFiltered.length" class="faq-cards__empty">
                  موردی برای نمایش وجود ندارد
                </p>
                <div v-else class="faq-cards__list">
                  <article
                    v-for="(row, index) in faqPaged"
                    :key="(row.id || 'faq') + '-' + index"
                    class="faq-card"
                  >
                    <div class="faq-card__header">
                      <span class="faq-card__badge">سؤال</span>
                      <time v-if="row.createdDate" class="faq-card__date">{{
                        row.createdDate
                      }}</time>
                    </div>
                    <p
                      class="faq-card__q"
                      :class="{ 'is-clamp': !isFaqExpanded(row.id) }"
                    >
                      {{ row.question || "—" }}
                    </p>
                    <div class="faq-card__answer">
                      <span class="faq-card__badge faq-card__badge--answer"
                        >پاسخ</span
                      >
                      <p
                        class="faq-card__a"
                        :class="{ 'is-clamp': !isFaqExpanded(row.id) }"
                      >
                        {{ row.answer || "—" }}
                      </p>
                    </div>
                    <div class="faq-card__actions">
                      <button
                        v-if="isFaqLong(row)"
                        type="button"
                        class="faq-card__more"
                        @click="toggleFaqExpand(row.id)"
                      >
                        {{
                          isFaqExpanded(row.id) ? "نمایش کمتر" : "نمایش کامل"
                        }}
                      </button>
                      <button
                        type="button"
                        class="faq-card__delete"
                        @click="onDelete(row)"
                      >
                        <i class="fas fa-trash" aria-hidden="true"></i>
                        حذف
                      </button>
                    </div>
                  </article>
                </div>
                <div
                  v-if="faqPageCount > 1"
                  class="faq-cards__pager"
                >
                  <button
                    type="button"
                    class="faq-cards__pager-btn"
                    :disabled="faqPage <= 1"
                    @click="faqPage = faqPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="faq-cards__pager-info"
                    >{{ faqPage }} از {{ faqPageCount }}</span
                  >
                  <button
                    type="button"
                    class="faq-cards__pager-btn"
                    :disabled="faqPage >= faqPageCount"
                    @click="faqPage = faqPage + 1"
                  >
                    بعدی
                  </button>
                </div>
              </div>
              <div class="faq-table">
                <vue-bootstrap4-table
                  :rows="rows"
                  :columns="columns"
                  :config="config"
                  :classes="classes"
                  :actions="actions"
                  @on-add="onAdd"
                >
                  <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                  </template>
                  <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                  </template>
                  <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                  </template>
                  <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                  </template>
                  <template slot="Action" slot-scope="props">
                    <button
                      type="button"
                      title="حذف"
                      class="btn btn-danger ml-2"
                      @click="onDelete(props.row)"
                      style="font-size: 14px !important"
                      dir="ltr"
                    >
                      <span class="fas fa-trash" tabindex="-1"></span>
                    </button>
                  </template>
                </vue-bootstrap4-table>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
  </div>
</template>

<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";

export default {
  components: {
    Panel,
    NetPaCard,
    VueBootstrap4Table,
  },
  data() {
    return {
      faqSearch: "",
      faqPage: 1,
      faqPerPage: 10,
      expandedFaq: {},
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "سوال",
          name: "question",
        },
        {
          label: "پاسخ",
          name: "answer",
        },
        {
          label: "تاریخ ایجاد",
          name: "createdDate",
        },
        {
          label: "عملیات",
          name: "Action",
          visibility: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page: 10,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      actions: [
        {
          btn_text: '<i style="font-size:15px" class="fas fa-plus"></i>',
          event_name: "on-add",
          class: "btn btn-success rounded",
          event_payload: {
            msg: "my custom msg",
          },
        },
      ],
    };
  },
  computed: {
    faqFiltered() {
      const q = (this.faqSearch || "").trim();
      if (!q) return this.rows;
      return this.rows.filter((row) => {
        const question = (row.question || "").toString();
        const answer = (row.answer || "").toString();
        return question.indexOf(q) !== -1 || answer.indexOf(q) !== -1;
      });
    },
    faqPageCount() {
      return Math.max(
        1,
        Math.ceil(this.faqFiltered.length / this.faqPerPage) || 1,
      );
    },
    faqPaged() {
      const start = (this.faqPage - 1) * this.faqPerPage;
      return this.faqFiltered.slice(start, start + this.faqPerPage);
    },
  },
  watch: {
    faqSearch() {
      this.faqPage = 1;
    },
  },
  methods: {
    isFaqLong(row) {
      const question = (row.question || "").toString();
      const answer = (row.answer || "").toString();
      return question.length > 90 || answer.length > 140;
    },
    isFaqExpanded(id) {
      return !!this.expandedFaq[id];
    },
    toggleFaqExpand(id) {
      this.$set(this.expandedFaq, id, !this.expandedFaq[id]);
    },
    getFAQList() {
      var axios = require("axios");
      var config = {
        method: "GET",
        url: this.$GetapiBase() + "FAQ/Get",
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            response.data.status === "Ok" &&
            response.data.result &&
            Array.isArray(response.data.result) &&
            response.data.result.length > 0
          ) {
            let allItems = response.data.result.filter(
              (item) => item.isDeleted === false,
            );
            if (allItems.length > 0)
              if (allItems.length > 10) {
                this.config.pagination = true;
              } else {
                this.config.pagination = false;
              }

            this.rows = allItems.map((item, index) => {
              return {
                id: item.id,
                question: item.question,
                answer: item.answer,
                createdDate: item.createdDate || "",
              };
            });
          } else {
            this.rows = [];
            this.config.pagination = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching FAQ data:", error);
          this.rows = [];
          this.$mySweetDefaultTost(
            "خطا",
            "خطا در دریافت اطلاعات",
            "error",
            2000,
          );
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
    onAdd() {
      this.$router.push({ name: "FAQCreate" });
    },
    onDelete(row) {
      this.$swal({
        title: "حذف پرسش و پاسخ",
        text: "آیا مطمئن هستید که می‌خواهید این پرسش و پاسخ را حذف کنید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "بله، حذف کن",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteFAQ(row.id);
        }
      });
    },
    deleteFAQ(id) {
      const formData = new FormData();
      formData.append("id", id);

      const DataAxiosDeleteFAQ = {
        ArryfildValue: formData,
        Method: "DELETE",
        Action: "FAQ/Delete",
        Token: this.$session.get("TokenNetPa"),
      };

      this.$PostFormData(DataAxiosDeleteFAQ)
        .then((data) => {
          if (data.status === "Ok" || data.success === true) {
            this.$mySweetDefault(
              "حذف موفق",
              "پرسش و پاسخ با موفقیت حذف شد",
              "success",
              2000,
            );
            this.getFAQList();
          } else {
            this.$mySweetDefaultTost(
              "خطا",
              "خطا در حذف پرسش و پاسخ",
              "error",
              2000,
            );
          }
        })
        .catch((error) => {
          console.error("Error deleting FAQ:", error);
          this.$mySweetDefaultTost(
            "خطا",
            "خطا در حذف پرسش و پاسخ",
            "error",
            2000,
          );
        });
    },
  },
  mounted() {
    this.getFAQList();
  },
};
</script>

<style scoped>
.faq-cards {
  display: none;
}

.faq-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.faq-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.faq-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.faq-cards__add {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 40px;
  padding: 0.3rem 0.85rem;
  color: #2f7a1f;
  border: 1px solid #b7dfb0;
  border-radius: 12px;
  background: #eef8ec;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.faq-cards__add:hover,
.faq-cards__add:focus {
  color: #fff;
  border-color: #2f7a1f;
  background: #2f7a1f;
}

.faq-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.faq-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.faq-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.faq-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 0.45rem;
}

.faq-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0.1rem 0.55rem;
  color: #287db4;
  font-size: 11px;
  font-weight: 800;
  border-radius: 999px;
  background: #edf5fb;
}

.faq-card__badge--answer {
  color: #166c3b;
  background: #f3faf6;
}

.faq-card__date {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.faq-card__q,
.faq-card__a {
  margin: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.8;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
}

.faq-card__q {
  margin-bottom: 0.7rem;
  font-size: 14px;
  font-weight: 800;
}

.faq-card__answer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
}

.faq-card__a {
  font-weight: 600;
  color: #31465f;
}

.faq-card__q.is-clamp,
.faq-card__a.is-clamp {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.faq-card__q.is-clamp {
  -webkit-line-clamp: 3;
}

.faq-card__a.is-clamp {
  -webkit-line-clamp: 5;
}

.faq-card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.faq-card__more,
.faq-card__delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  padding: 0.3rem 0.75rem;
  border: 1px solid;
  border-radius: 10px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.faq-card__more {
  color: #287db4;
  border-color: #cfe4f2;
  background: #edf5fb;
}

.faq-card__delete {
  margin-right: auto;
  color: #b44f46;
  border-color: #f0d4d1;
  background: #fcefed;
}

.faq-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.faq-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.faq-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.faq-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .faq-cards {
    display: block;
  }

  .faq-table {
    display: none;
  }

  .faq-cards__add {
    width: auto;
  }
}
</style>
